import { filter, find } from "lodash";
import React, { Fragment } from "react";
import { useListContext } from "react-admin";
import BulkActionApproveButton from "./BulkActionApproveButton";
import BulkActionDeleteButton from "./BulkActionDeleteButton";
import BulkActionUntagButton from "./BulkActionUntagButton";

const BulkConfirmationButton = () => {
  const { data, selectedIds, filterValues } = useListContext();
  const filteredData = filter(data, (item) => selectedIds.includes(item.id));

  // Find if the selected commercial document has tagged credit note.
  // It is also used to show or hide the bulk untag credit note button
  const taggedCreditNote = find(
    filteredData,
    (item) => item.invoiceTaggedMbcRef,
  );

  return (
    <Fragment>
      <BulkActionApproveButton
        filteredData={filteredData}
        documentType={filterValues.Type}
      />
      <BulkActionDeleteButton
        filteredData={filteredData}
        documentType={filterValues.Type}
      />
      {filterValues.Type === "CreditNote" && taggedCreditNote && (
        <BulkActionUntagButton
          filteredData={filteredData}
          documentType={filterValues.Type}
        />
      )}
    </Fragment>
  );
};

export default BulkConfirmationButton;
